/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

//Utils
import events from '../../../../lib/events.js';
import {dateTimeFormats} from 'helpers/constants';

//Components
import Loader from '../../../components/loader.jsx';
import Pagination from '../../../components/layout/pagination.jsx';
import PrintableFullReport from '../components/printableFullReport.jsx';
import ReportDropDown from '../components/reportDropDown.jsx';
import {formatCurrency} from '../../../helpers/dashboardFormatter.jsx';
import {formatStaticCurrency} from '../../../helpers/currencyHelper.jsx';

import {reportDateFormat} from 'helpers/constants';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

//Apis
import ReportApi from 'api/report';

const filterOptions = {
  store: '',
  storeOptions: [],
  poolType: '1,2,3',
  poolTypeOptions: [],
};

class SalesPerformanceReport extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    branches: PropTypes.any,
  };

  constructor(props) {
    super(props);

    filterOptions.store = this.props.branches.join();
    let {formatMessage} = this.props.intl;

    // Options come from Back-End, that's they remain in English
    filterOptions.storeOptions = [
      {value: this.props.branches.join(), label: formatMessage({id: 'general.all.stores'})},
    ];

    filterOptions.poolTypeOptions = [
      {
        value: '1,2,3',
        label: formatMessage({id: 'general.all.systems'}),
      },
      {
        value: '1',
        label: formatMessage({id: 'general.pools'}),
      },
      {
        value: '2',
        label: formatMessage({id: 'general.spas'}),
      },
      {
        value: '3',
        label: formatMessage({id: 'general.swim.spas'}),
      },
    ];

    for (let i = 0; i < this.props.branchesFull.length; i++) {
      filterOptions.storeOptions.push({
        value: this.props.branchesFull[i].id,
        label: this.props.branchesFull[i].name,
      });
    }
    this.state = {
      loaded: true,
      report: null,
      start: moment().subtract(30, 'day'),
      end: moment(),
      branches: this.props.branches,
      store: filterOptions.store,
      poolType: filterOptions.poolType,
      ...filterOptions,
      count: 0,
      total: 0,
      page: 1,
      showNoDataMessage: false,
    };
  }

  onPageChange = (page, event) => {
    const {count, fullReport} = this.state;
    const pagReport = fullReport.slice((page - 1) * count, count * page);

    this.setState({
      report: pagReport,
      page: page,
    });
  };

  getSummaryDetails = fullReport => {
    const data = {
      avg_purchase_value: 0,
      total_customers: 0,
      total_invoices_count: 0,
      total_purchase_value: 0,
      total_maintenance_systems: 0,
    };

    if (fullReport && fullReport.length && fullReport.length > 0) {
      data.total_customers = fullReport.length;
      data.total_invoices_count = fullReport.reduce((a, b) => a + b.invoice_count, 0);
      data.total_purchase_value = fullReport.reduce((a, b) => a + b.total_purchase_value, 0);
      data.avg_purchase_value = data.total_purchase_value / data.total_invoices_count;
      data.total_maintenance_systems = fullReport.reduce((a, b) => a + b.total_maintenance_systems, 0);
    }

    return data;
  };

  detailedView() {
    const reports = this.state.report;

    return (
      <div>
        <table className='table-biolab table-striped'>
          <thead style={{fontSize: '13px'}}>
            <tr>
              <th><FormattedMessage id="general.primary.contact"/></th>
              <th className='numeric-box'><FormattedMessage id="general.analysis"/></th>
              <th className='numeric-box'><FormattedMessage id="reports.bioguard.transactions"/></th>
              <th className='numeric-box'><FormattedMessage id="general.total.bioguard.sales"/></th>
              <th className='numeric-box'><FormattedMessage id="reports.average.sales.analysis"/></th>
              <th className='numeric-box'><FormattedMessage id="reports.last.bioguard.transaction"/></th>
            </tr>
          </thead>
          <tbody>
            {
            reports.map(row => {
              let customerLink = `#customer/${row.CustomerID}`;

              return (
                <tr key={row.CustomerID}>
                  <td>
                    <a href={customerLink}>{row.name !== null ? row.name : row.CustomerID}</a>
                  </td>
                  <td className='numeric-box'>{row.analysis_count}</td>
                  <td className='numeric-box'>{row.invoice_count}</td>
                  <td className='numeric-box'>{row.total_purchase_value ? formatCurrency(row.total_purchase_value) : ''}</td>
                  <td className='numeric-box'>{row.avg_purchase_value_per_analysis ? formatCurrency(row.avg_purchase_value_per_analysis) : ''}</td>
                  <td className='numeric-box custom-padding-right'>{row.last_purchase_amount ? formatCurrency(row.last_purchase_amount) : ''}</td>
                </tr>
              );
            })
          }
          </tbody>
        </table>
        <div className='center-pagination'>
          <Pagination
            onPageChange={this.onPageChange}
            page={this.state.page}
            count={this.state.count}
            total={this.state.total}/>
        </div>
      </div>
    );
  }

  exportReport = () => {
    const {start, end, store, poolType, branches} = this.state;

    ReportApi.getSalesPerformanceExport(
      this.props.intl.locale,
      store === '-1' ? branches : store,
      this.state.poolType,
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
    );
  };

  printReport = summary => {
    const {fullReport, start, end} = this.state;
    let {formatMessage} = this.props.intl;

    const table = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'name'},
      {name: formatMessage({id: 'general.analysis'}), key: 'analysis_count'},
      {name: formatMessage({id: 'reports.bioguard.transactions'}), key: 'invoice_count'},
      {name: formatMessage({id: 'general.total.bioguard.sales'}), key: 'total_purchase_value'},
      {name: formatMessage({id: 'reports.average.sales.analysis'}), key: 'avg_purchase_value_per_analysis'},
      {name: formatMessage({id: 'reports.last.bioguard.transaction'}), key: 'last_purchase_amount'},
    ];

    fullReport.forEach((element) => {
      element.total_purchase_value = formatStaticCurrency(element.total_purchase_value);
      element.avg_purchase_value_per_analysis = formatStaticCurrency(element.avg_purchase_value_per_analysis);
      element.last_purchase_amount = formatStaticCurrency(element.last_purchase_amount);
    }, this);

    const summaryColumns = [
      {name: formatMessage({id: 'reports.total.purchasing.accounts'}), key: 'total_customers'},
      {name: formatMessage({id: 'general.total.bioguard.sales'}), key: 'total_purchase_value'},
      {name: formatMessage({id: 'reports.average.sales.transactions'}), key: 'avg_purchase_value'},
      {name: formatMessage({id: 'reports.total.bioguard.transactions'}), key: 'total_invoices_count'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'total_maintenance_systems'},
    ];

    summary.total_purchase_value = formatStaticCurrency(summary.total_purchase_value);
    summary.avg_purchase_value = formatStaticCurrency(summary.avg_purchase_value);

    return (
      <PrintableFullReport
        end={end.format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={start.format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={summaryColumns}
        summaryData={summary}
        tableColumns={table}
        tableData={fullReport}
        title={formatMessage({id: 'reports.sales.performance'}) + ' ' + formatMessage({id: 'general.summary'})}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      start: moment().subtract(30, 'day'),
      end: moment(),
      store: filterOptions.store,
      poolType: filterOptions.poolType,
    });
  };

  roundValue = val => {
    if (val) {
      return (parseFloat(val) * 100 / 100).toFixed(2);
    } else {
      return 0;
    }
  };

  updateReport = () => {
    const {start, end, store, poolType, branches} = this.state;

    this.setState({
      fullReport: null,
      loaded: false,
    });

    ReportApi.getSalesPerformance(
      store,
      poolType,
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
    ).then(data => {
      if (data && data.length > 0) {
        this.setState({
          fullReport: data,
          report: data.slice(0, 20),
          count: 20,
          total: data.length,
          page: 1,
        });
      } else {
        this.setState({showNoDataMessage: true});
      }
    }).catch(err => {
      console.log(err);
      this.setState({showNoDataMessage: true});
    }).complete(() => {
      this.setState({
        loaded: true,
      });
    });
  };

  render() {
    const {
      start, end, store, storeOptions, poolType, poolTypeOptions, loaded, report, showNoDataMessage, fullReport,
    } = this.state;

    const summary = this.getSummaryDetails(fullReport);

    let {formatMessage} = this.props.intl;

    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id="reports.sales.performance.description"/></span>
        <div className="report-options">
          <div className="top-title-bar">
            <FormattedMessage id="general.report.options"/>
          </div>
          <div className='select-options container'>
            <div className='row'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.from"/></label>
                  <div className='editable-datepicker'>
                    <DatePicker
                      selected={start}
                      dateFormat={reportDateFormat}
                      maxDate={end.clone().subtract(1, 'days')}
                      onChange={((e) => {
                        this.setState({start: e});
                      })}
                    />
                  </div>
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.to"/></label>
                  <div className='editable-datepicker'>
                    <DatePicker
                      selected={end}
                      dateFormat={reportDateFormat}
                      minDate={start.clone()}
                      maxDate={moment()}
                      onChange={((e) => {
                        this.setState({end: e});
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={store}
                                label={formatMessage({id: 'general.store'})}
                                onChange={((e) => {
                                  this.setState({store: e.target.value});
                                })}
                                options={storeOptions}/>
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={poolType}
                                label={formatMessage({id: 'general.system.type'})}
                                onChange={((e) => {
                                  this.setState({poolType: e.target.value});
                                })}
                                options={poolTypeOptions}/>
              </div>
            </div>
            <div className='manage-options'>
              <div className='col-sm-12 button-group'>
                <span className='reset-button pull-right'
                      onClick={this.resetFilters}><FormattedMessage id="general.reset"/></span>
                <button className='btn btn-primary pull-right'
                        onClick={this.updateReport}><FormattedMessage id="reports.update.summary"/></button>
              </div>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          {fullReport ?
            <div className='col-sm-12 summary-container'>
              <div className='row'>
                <h2>
                  <FormattedMessage id="reports.report.summary"/>
                  <span className='summary-date'> | <FormattedMessage id="general.date.range"
                                                                      values={{
                                                                        start: start.format(dateTimeFormats.numeralDate),
                                                                        end: end.format(dateTimeFormats.numeralDate),
                                                                      }} />
                  </span>
                </h2>
                <p className='description'><FormattedMessage id="reports.reveal.report.summary"/></p>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.total.purchasing.accounts"/></label>
                  <div>{summary.total_customers}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.bioguard.sales"/></label>
                  <div>{formatCurrency(summary.total_purchase_value)}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.average.sales.transactions"/></label>
                  <div>{formatCurrency(summary.avg_purchase_value)}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.total.bioguard.transactions"/></label>
                  <div>{summary.total_invoices_count}</div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.total.maintenance'/></label>
                  <div>{summary.total_maintenance_systems}</div>
                </div>
              </div>
              <div>
                {report ? this.detailedView() : <div/>}
              </div>
            </div> :
            <div className='summary-container'>
              <h2><FormattedMessage id="reports.report.summary"/></h2>
              <p><FormattedMessage id="reports.reveal.report.summary"/></p>
              {showNoDataMessage ?
                <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
              <div className="container-fluid custom-container-margins">
                <div/>
              </div>
            </div>}
          <div className='col-sm-12 button-group shift-right'>
            <button className='btn btn-default pull-right'
                    disabled={(report === null)}
                    onClick={(() => {
                      events.publish('print', this.printReport(summary));
                    })}><FormattedMessage id="reports.print.summary"/></button>
            <button className='btn btn-primary pull-right'
                    onClick={this.exportReport}><FormattedMessage id="reports.export.report"/></button>
          </div>
        </Loader>
      </div>
    );
  }
}

export default injectIntl(SalesPerformanceReport);
